export default {
	'stores-are-being-brought-in': 'Mağazalar getiriliyor'
}